/**
 * 关键路线数据模型（核心逻辑层）
 */
import { services } from '../services';


export const ThematicRouteModel = {
  /**
   * 获取关键路线详细信息
   * @returns {Promise<Array>} 格式化后的区域列表
   */
  getDetail: async (params) => {
    console.log('ThematicRouteModel.getDetail', params);
    // 调用接口
    const response = await services.thematicRoute.getDetail(params);
    if (!response.ok) throw new Error('区域接口请求失败');
    const data = await response.json();
    return data?.result;
  },

};